/**
 * Application Configuration
 * 
 * This file contains centralized configuration settings for the application.
 * It's designed to make environment-specific settings easily accessible throughout
 * the application while providing sensible defaults.
 */

/**
 * Google Maps and Places API Configuration
 */
export const GOOGLE_MAPS_CONFIG = {
  /**
   * API Key for Google Maps and Places API
   * Reads from environment variable or falls back to empty string
   */
  apiKey: process.env.REACT_APP_GOOGLE_PLACES_API_KEY || '',
  
  /**
   * Default options for Maps/Places API initialization
   */
  defaultOptions: {
    version: 'weekly',
    libraries: ['places'],
    language: 'en'
  },
  
  /**
   * Timeout values for API operations (in milliseconds)
   */
  timeouts: {
    initialization: 10000,  // 10 seconds for API initialization
    placesAutocomplete: 5000,  // 5 seconds for autocomplete requests
    placeDetails: 7000  // 7 seconds for place details requests
  }
};

/**
 * Application Meta Configuration
 */
export const APP_CONFIG = {
  /**
   * Application name
   */
  name: 'Trip Planner',
  
  /**
   * Application version
   */
  version: '1.0.0',
  
  /**
   * Default date format for display
   */
  dateFormat: 'MMMM d, yyyy',
  
  /**
   * Default date+time format for display
   */
  dateTimeFormat: 'MMMM d, yyyy h:mm aa'
};

/**
 * Default export for backward compatibility
 */
export default {
  GOOGLE_MAPS_CONFIG,
  APP_CONFIG
}; 